import styled from 'styled-components';
import { variablesList } from 'constants/variablesList';
import { themesList } from 'constants/themesList';
import { ThemeList } from 'store/ducks/globalTypes';
import { IThemeSelectorProps } from 'store/ducks/Global/types';

export const ThemeContainer = styled('div')<IThemeSelectorProps>`
  .ant-tabs .ant-tabs-nav .ant-tabs-tab {
    background-color: ${(props) =>
      variablesList[props.theme as ThemeList].defaultTabBg};
  }

  .ant-tabs-tab-active {
    background: ${(props) =>
      variablesList[props.theme as ThemeList].tabSelected} !important;
  }

  .ant-btn.ant-btn-primary.ant-btn-icon-only:not(:disabled) {
    background-color: ${(props) =>
      variablesList[props.theme as ThemeList].iconButtonBg} !important;

    &:hover {
      background-color: ${(props) =>
        variablesList[props.theme as ThemeList].iconButtonBgHover} !important;
    }
  }

  .ant-menu.ant-menu-root.ant-menu-horizontal {
    background-color: ${(props) =>
      variablesList[props.theme as ThemeList].menuBackground};
    border: ${(props) => variablesList[props.theme as ThemeList].menuBorder};
    color: ${(props) => variablesList[props.theme as ThemeList].menuColor};

    li {
      span {
        span {
          color: ${(props) =>
            variablesList[props.theme as ThemeList].menuColor};
        }
      }
    }
  }

  .ant-menu-item:hover:not(.ant-menu-item-selected):not(
      .ant-menu-submenu-selected
    ),
  > .ant-menu
    .ant-menu-item:hover:not(.ant-menu-item-selected):not(
      .ant-menu-submenu-selected
    ) {
    color: ${(props) => variablesList[props.theme as ThemeList].menuColorHover};
  }

  .ant-menu > .ant-menu-item-selected:before {
    background-color: ${(props) =>
      variablesList[props.theme as ThemeList].menuItemBg};
  }

  .ant-btn-primary:not(:disabled) {
    background-color: ${(props) => {
      const themeKey = props.theme as string;
      return themesList[themeKey as keyof typeof themesList]?.actionButtons;
    }};
    border-color: ${(props) => {
      const themeKey = props.theme as string;
      return themesList[themeKey as keyof typeof themesList]?.actionButtons;
    }};
    color: ${(props) => {
      const themeKey = props.theme as string;
      const currentTheme = themesList[
        themeKey as keyof typeof themesList
      ] as any;
      return currentTheme?.colorPrimaryText || '#ffffff';
    }};
  }

  .ant-btn-primary:not(:disabled):hover {
    background-color: ${(props) => {
      const themeKey = props.theme as string;
      return themesList[themeKey as keyof typeof themesList]
        ?.actionButtonsHover;
    }};
    border-color: ${(props) => {
      const themeKey = props.theme as string;
      return themesList[themeKey as keyof typeof themesList]
        ?.actionButtonsHover;
    }};
    color: ${(props) => {
      const themeKey = props.theme as string;
      const currentTheme = themesList[
        themeKey as keyof typeof themesList
      ] as any;
      return currentTheme?.colorPrimaryText || '#ffffff';
    }};
  }

  .drag-text-box {
    border-bottom: ${(props) =>
      variablesList[props.theme as ThemeList].colorBorder};
  }

  .ant-checkbox:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    border: ${(props) =>
      variablesList[props.theme as ThemeList].checkboxBorder};
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    border: 2px solid #aeaeae;
  }

  .ant-typography {
    color: ${(props) =>
      variablesList[props.theme as ThemeList].colorTypography};
  }

  .ant-table-tbody .ant-table-cell {
    div,
    textarea,
    button {
      color: ${(props) =>
        variablesList[props.theme as ThemeList].tableCellColor};
    }
  }

  .ant-picker-dropdown .ant-picker-today-btn {
    color: ${(props) =>
      variablesList[props.theme as ThemeList].datePickerDayColor};
  }

  .color-typography {
    color: ${(props) =>
      variablesList[props.theme as ThemeList].colorTypography};
  }

  .ant-table-cell-row-hover {
    background: ${(props) => variablesList[props.theme as ThemeList].bgColor};
  }

  .nested-table-wrapper .ant-table-wrapper .ant-table {
    border-bottom: ${(props) =>
      variablesList[props.theme as ThemeList].nestedTableBorder};
  }

  .cln-req-wrapper .ant-table-wrapper .ant-table {
    .ant-table-tbody > tr:not(:first-child) > td {
      border-bottom: ${(props) =>
        variablesList[props.theme as ThemeList].nestedTableBorder};
    }
  }

  ${(props) => {
    const themeKey = props.theme as string;
    const currentTheme = themesList[themeKey as keyof typeof themesList];

    if (!currentTheme) return '';

    return `
      --theme-primary-text: ${
        (currentTheme as any).colorPrimaryText || '#000000'
      };
      --theme-main-color: ${currentTheme.mainColor};
      --theme-primary: ${currentTheme.colorPrimary};
      
      .theme-text {
        color: var(--theme-primary-text);
      }
      
      .theme-heading {
        color: var(--theme-primary-text);
      }
      
      .ant-table-thead .ant-table-cell {
        color: var(--theme-primary-text);
      }
      
      ${
        props.theme === 'deepNavyTheme'
          ? `
        .gaps-input,
        .gaps-textarea {
          color: #000000;
        }
      `
          : ''
      }
      
      ${
        props.theme === 'deepNavyTheme' || props.theme === 'darkUITheme'
          ? `
        .theme-icon {
          color: var(--theme-main-color);
        }
      `
          : ''
      }
    `;
  }}

  ${(props) =>
    props.theme === 'deepNavyTheme' &&
    `
    .ant-input,
    .ant-input:focus,
    textarea,
    textarea:focus {
      color: #000000 !important;
    }
    
    .ant-table-tbody .ant-table-cell div,
    .nested-table .ant-table-tbody .ant-table-cell div,
    .nested-table .ant-table-tbody .ant-table-cell:nth-child(1) div,
    .nested-table .ant-table-tbody .ant-table-cell:nth-child(1) * {
      color: #000000 !important;
    }
    
    .anticon-delete,
    .ant-btn .anticon-delete,
    .ant-btn-circle .anticon-delete,
    .ant-btn-primary .anticon-delete,
    .ant-table .anticon-delete,
    .ant-table-tbody .anticon-delete,
    .ant-table-row .anticon-delete,
    .nested-table .anticon-delete,
    .ant-table-expanded-row .anticon-delete,
    .ant-table-expanded-row-fixed .anticon-delete,
    tr .anticon-delete,
    td .anticon-delete,
    div .anticon-delete {
      color: #FFFFFF !important;
    }
    
    .anticon,
    .ant-btn .anticon,
    .ant-btn-circle .anticon,
    .ant-btn-primary .anticon,
    .ant-table .anticon,
    .ant-table-tbody .anticon,
    .ant-table-row .anticon,
    .nested-table .anticon,
    .ant-table-expanded-row .anticon,
    .ant-table-expanded-row-fixed .anticon,
    tr .anticon,
    td .anticon,
    div .anticon {
      color: #FFFFFF !important;
    }
    
    .ant-table-expanded-row .ant-btn-circle,
    .nested-table .ant-btn-circle,
    .ant-table-tbody .ant-btn-circle {
      .anticon {
        color: #FFFFFF !important;
      }
    }
  `}

  ${(props) => {
    const themeKey = props.theme as string;
    const currentTheme = themesList[themeKey as keyof typeof themesList] as any;
    return (
      props.theme === 'darkUITheme' &&
      `
    .ant-table-tbody .ant-table-cell .anticon,
    .ant-table-tbody .ant-table-cell button .anticon,
    .ant-table-tbody .ant-table-cell .ant-btn .anticon {
      color: ${currentTheme?.mainColor};
    }

    .ant-tree .ant-tree-switcher .ant-tree-switcher-icon,
    .ant-tree .ant-tree-switcher .anticon {
      color: ${currentTheme?.mainColor};
    }

    .ant-tree-show-line .ant-tree-switcher {
      background: transparent;
      color: ${currentTheme?.mainColor};
    }
  `
    );
  }}

  ${(props) =>
    (props.theme === 'deepNavyTheme' || props.theme === 'darkUITheme') &&
    `
    h1, h2, h3, h4, h5, h6 {
      color: #FFFFFF !important;
    }
    
    .ant-table-thead .ant-table-cell,
    .ant-table-thead th,
    .ant-table-thead .ant-table-column-title,
    .ant-table-thead span {
      color: #FFFFFF !important;
    }
    
    .step-item,
    .step-title,
    .compliance-step,
    .workflow-step,
    .process-step,
    .ant-steps-item-title,
    .ant-timeline-item-content,
    .step-label,
    .step-name {
      color: #FFFFFF !important;
    }
    
    .filter-header,
    .filter-label,
    .filter-title,
    .main-filter,
    .ant-form-item-label,
    .ant-form-item-label > label,
    label {
      color: #FFFFFF !important;
    }
    
    .ant-steps .ant-steps-item-title {
      color: #FFFFFF !important;
    }
    
    .ant-timeline .ant-timeline-item-content {
      color: #FFFFFF !important;
    }
    
    .ant-btn:not(:disabled):not(.ant-btn-icon-only) {
      filter: brightness(1.5) !important;
    }
    
    .ant-btn:not(.ant-btn-primary):not(:disabled):not(.ant-btn-icon-only) {
      filter: brightness(1.8) !important;
    }
    
    .ant-btn.ant-btn-primary.ant-btn-icon-only:not(:disabled) {
      filter: none !important;
    }
    
    button[type="submit"]:not(:disabled),
    .save-btn:not(:disabled),
    .ant-btn-primary:not(:disabled):not(.ant-btn-icon-only) {
      background-color: #1890ff !important;
      border-color: #1890ff !important;
      filter: none !important;
      color: #000000 !important;
    }
    
    button[type="submit"]:not(:disabled):hover,
    .save-btn:not(:disabled):hover,
    .ant-btn-primary:not(:disabled):not(.ant-btn-icon-only):hover {
      background-color: #40a9ff !important;
      border-color: #40a9ff !important;
      color: #FFFFFF !important;
    }
    
    .ant-pagination-total-text,
    .ant-pagination-simple-pager,
    .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
    .ant-pagination-jump-next .ant-pagination-item-ellipsis,
    .ant-pagination-options-quick-jumper,
    .ant-pagination-options-quick-jumper input,
    .ant-pagination-options {
      color: #FFFFFF !important;
    }
    
    .ant-pagination .ant-pagination-options-quick-jumper::before,
    .ant-pagination .ant-pagination-options-quick-jumper::after {
      color: #FFFFFF !important;
    }
  `}

  ${(props) => {
    const currentTheme = themesList['bluishTheme'] as any;
    return (
      props.theme === 'bluishTheme' &&
      `
    .ant-btn:not(:disabled) span,
    .ant-btn:not(:disabled) .anticon {
      color: ${currentTheme?.colorPrimaryText};
    }

    .ant-upload .anticon,
    .ant-upload span,
    .ant-upload-list-item-name {
      color: ${themesList['bluishTheme'].colorPrimary};
    }
  `
    );
  }}

  ${(props) =>
    (props.theme === 'pinkUITheme' || props.theme === 'lightUITheme') &&
    `
    .ant-table-thead .ant-table-cell,
    .ant-table-thead th,
    .ant-table-thead .ant-table-column-title,
    .ant-table-thead span {
      color: #000000 !important;
    }
  `}

  ${(props) => {
    return (
      props.theme === 'turquoiseTheme' &&
      `
    .ant-table-thead .ant-table-cell,
    .ant-table-thead th {
      color: ${themesList.turquoiseTheme.colorPrimaryText} !important;
    }
    
    .ant-modal .ant-modal-header .ant-modal-title {
      color: ${themesList.turquoiseTheme.colorPrimaryText};
    }
    
    .ant-modal .ant-modal-body {
      color: ${themesList.turquoiseTheme.colorPrimaryText};
    }
  `
    );
  }}
`;
